// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".contact_list-link{display:inline-flex;text-decoration:none;align-items:center}.contact_list-link:hover{color:#ea8d9a}.contact_list-link-icon-wrapper{flex:0 0 auto;overflow:hidden;margin-left:.35em;transform:translateY(-.1em);color:#02504d;transition:color .25s ease 0s}.contact_list-link:hover .contact_list-link-icon-wrapper{color:#ea8d9a;transition:color 0s .35s}.contact_list-link-icon{width:.6em;height:.6em}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
